import {IAbstractModule, IModuleType} from "@/model/Locker/IModule";

export const ModuleTintoreriaOld: IAbstractModule = {
  type: IModuleType.tintoreria,
  name: 'Tintoreria 4 old',
  hasScreen: false,
  columns: [
    [
      {
        name: "T5",
        connector: "5",
        cell_size_id: 1,
        accessible: false,
      },
      {
        name: "T6",
        connector: "6",
        cell_size_id: 1,
        accessible: true,
      },
    ],
    [
      {
        name: "T7",
        connector: "7",
        cell_size_id: 1,
        accessible: false,
      },
      {
        name: "T8",
        connector: "8",
        cell_size_id: 1,
        accessible: true,
      },
    ],
  ]
};
